import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

const headerVariants = {
  hidden: { opacity: 0, y: -12 },
  visible: { opacity: 1, y: 0 }
};

const contentVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.04 } }
};

function FinListPageLayout({
  title,
  subtitle,
  description,
  icon: Icon,
  actions,
  children,
  className,
  contentClassName,
  maxWidth = 'max-w-7xl',
  padding = 'px-4 sm:px-6 lg:px-8',
  id,
  as = 'section'
}) {
  const Component = as;

  return (
    <Component id={id} className={cn('finlist-page', className)}>
      <div className={cn('finlist-page__shell', maxWidth, padding)}>
        {(title || subtitle || actions) && (
          <motion.header
            initial="hidden"
            animate="visible"
            variants={headerVariants}
            className={cn('finlist-page__header', 'gap-6 lg:flex-row lg:items-center lg:justify-between')}
          >
            <div className="space-y-3">
              {subtitle && (
                <p className="finlist-page__subtitle text-balance">{subtitle}</p>
              )}
              <div className="flex items-start gap-3">
                {Icon && (
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white/80 text-brand-600 shadow-finlist-sm dark:bg-white/10">
                    <Icon className="h-6 w-6" />
                  </span>
                )}
                <div>
                  {title && (
                    <h1 className="finlist-page__title text-balance">{title}</h1>
                  )}
                  {description && (
                    <p className="text-base text-slate-600 dark:text-slate-300 text-balance">{description}</p>
                  )}
                </div>
              </div>
            </div>
            {actions && (
              <div className="flex flex-wrap items-center gap-3">
                {actions}
              </div>
            )}
          </motion.header>
        )}

        <motion.div
          initial="hidden"
          animate="visible"
          variants={contentVariants}
          className={cn('space-y-6', contentClassName)}
        >
          {children}
        </motion.div>
      </div>
    </Component>
  );
}

FinListPageLayout.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.node,
  icon: PropTypes.elementType,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  maxWidth: PropTypes.string,
  padding: PropTypes.string,
  id: PropTypes.string,
  as: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.elementType
  ])
};

export default FinListPageLayout;
